import { orchestrator } from 'satcheljs';
import { onMakeDefaultTimeZone } from '../actions/timestripActions';
import { getSurfaceStore } from 'owa-calendar-surface-surface-store';
import { updateTimeZones } from 'owa-calendar-surface';
import { updateServiceConfig } from 'owa-service/lib/config';
import { setLocalTimeZone } from 'owa-datetime-store';
import { updateUserConfiguration } from 'owa-session-store';
import { getRegionalOptionsServiceRequests } from 'owa-regional-options-service';

orchestrator(onMakeDefaultTimeZone, async actionMessage => {
    const newTimeZone = actionMessage.timeZone;
    const surfaceStore = getSurfaceStore();

    // Save
    updateServiceConfig({ timezone: newTimeZone });

    // Update owa-datetime
    setLocalTimeZone(newTimeZone);

    // Update UserOptions
    updateUserConfiguration(config => {
        config.UserOptions.TimeZone = newTimeZone;
    });

    const promises: Promise<any>[] = getRegionalOptionsServiceRequests(false, true, false, null);
    await Promise.all(promises);

    // Update surface store
    updateTimeZones([newTimeZone], surfaceStore);
});
